import { motion } from "framer-motion";
export default function ContentSection({
  title,
  children,
  variant = "",
  delay = 0
}) {
  const containerClasses = variant === "card" 
    ? "glass-card rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-10" 
    : "px-2";

  console.log("containerClasses", containerClasses);
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ 
        duration: 0.8, 
        delay,
        ease: [0.22, 1, 0.36, 1] 
      }}
      className={containerClasses}
    >
      <h3 className="text-2xl md:text-3xl font-normal text-text-[#FD5B38] mb-4 md:mb-6">
        {title}
      </h3>
      <div className="space-y-4 md:space-y-6">
        {children}
      </div>
    </motion.div>
  );
}

export function Paragraph({ children }) {
  return (
    <p className="text-base md:text-lg lg:text-xl text-text-secondary leading-relaxed">
      {children}
    </p>
  );
}
